import { Outlet, createFileRoute } from "@tanstack/react-router";

import { requireMedical } from "./-utils/require-medical";

export const Route = createFileRoute("/_app/clinica")({
	beforeLoad: requireMedical,
	component: Outlet,
});
